import React, { useState, useEffect, forwardRef } from 'react';
import { motion } from 'framer-motion';

export const Scene1 = forwardRef(function Scene1(props, ref) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 400),
      setTimeout(() => setPhase(2), 1200),
      setTimeout(() => setPhase(3), 2000),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  return (
    <motion.div
      ref={ref}
      className="absolute inset-0 flex items-center justify-center p-12"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 1.05, filter: 'blur(10px)' }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="max-w-4xl text-center flex flex-col gap-6">
        <motion.h1
          className="text-5xl md:text-7xl font-bold leading-tight"
          style={{ fontFamily: 'Playfair Display, serif', color: '#004D35' }}
          initial={{ opacity: 0, y: 20 }}
          animate={phase >= 1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          Who do I trust with my taxes?
        </motion.h1>

        <motion.h1
          className="text-5xl md:text-7xl font-bold leading-tight"
          style={{ fontFamily: 'Playfair Display, serif', color: '#004D35' }}
          initial={{ opacity: 0, y: 20 }}
          animate={phase >= 2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          My payroll?
        </motion.h1>

        <motion.h1
          className="text-5xl md:text-7xl font-bold leading-tight text-[#C5A431]"
          style={{ fontFamily: 'Playfair Display, serif' }}
          initial={{ opacity: 0, y: 20 }}
          animate={phase >= 3 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          My growth?
        </motion.h1>
      </div>
    </motion.div>
  );
});
